import React from 'react';
import {
	SimpleForm,
	Edit,
	FileInput,
	FileField,
} from 'react-admin';

export default () => (
	<Edit>
		<SimpleForm>
			<FileInput source="content">
				<FileField source="src" />
			</FileInput>
		</SimpleForm>
	</Edit>
);
